import { Component, Input, OnInit, signal } from "@angular/core";
import { Router } from "@angular/router";
import { LoaderService } from "../../service/loader.service";
import { Message } from "../../service/message.service";
import { RestService } from "../../service/rest.service";
import { api } from "../../../environments/environment";

@Component({
  selector: "app-preference",
  templateUrl: "./preference.component.html",
  styles: [],
  standalone: false,
})
export class PreferenceComponent implements OnInit {
  constructor(
    private router: Router,
    private message: Message,
    private rest: RestService,
    private loader: LoaderService
  ) { }

  filters: any = signal([])
  filtersToApply: any = {
    exact: false,
  }
  savedFilters: any = {}
  active: boolean = false
  isSubscribed = false
  newFiltersToApply = false
  noChangeFilter:any
  ngOnInit(): void {
    this.getFilters()
  }

  bruh() {
    console.log(this.filtersToApply);
  }

  getFilters() {
    this.loader.on()
    this.rest.get('/notice/filters').subscribe({
      next: (value: any) => {
        delete value.ambitoTerritoriale
        delete value.programma
        delete value.tipologiaBando
        this.noChangeFilter = value
        let newFilters: any[] = []
        for (const key in value) {
          if (!Object.hasOwn(value, key)) continue;
          if (key !== 'status') {
            if (key == 'codiciAteco') {
              let myNewLabels = value[key].map((label: any) => {
                label.name = `${label.name} - ${label.TITOLO_ATECO_2022 ? label.TITOLO_ATECO_2022 : 'NO DESC'}`
                return label
              })
              newFilters.push({
                name: key,
                labels: myNewLabels
              })
            } else {
              newFilters.push({
                name: key,
                labels: value[key]
              })
            }
          } else {
            newFilters.push({
              name: key,
              labels: value[key].map((res: string) => { return { label: res } })
            })
          }
        }
        this.filters.set(newFilters)
        console.log(this.filters());

        this.getPreference()
        setTimeout(() => {
          this.loader.off()
        }, 0);
      },
      error: (value: any) => {
        this.loader.off(true)
      },
    })
  }

  savePreference() {
    let params: any = {
      active: this.active,
      filters: {}
    }
    for (const key in this.filtersToApply) {
      if (!Object.hasOwn(this.filtersToApply, key)) continue;
      const element = this.filtersToApply[key];
      params.filters[key] = (key == 'status' || key == 'exact' || key == 'order' || key == 'search') ? element : element.map((res: any) => res?.id)
    }
    this.loader.on()
    let functionTocall = this.isSubscribed ? this.rest.patch('/newsletter-preference', params) : this.rest.post('/newsletter-preference', params)
    functionTocall.subscribe({
      next: (value: any) => {
        this.isSubscribed = true
        this.loader.off(true)
      },
      error: () => {
        this.loader.off(true)
      }
    })
  }

  getPreference() {
    this.loader.on()
    this.rest.get('/newsletter-preference').subscribe({
      next: (value: any) => {
        this.active = value.active
        this.isSubscribed = value ? true : false
        this.loader.off(true)
        for (const key in value.filters) {
          if (key == 'exact' || key == 'search' || key == 'status') {
            console.log(key, value.filters[key]);
          }else{
            console.log(value.filters[key]);
            value.filters[key].forEach((savedFilterElement:number) => {
              let newElementToAdd =  this.noChangeFilter[key].find((noCHangeFilterElement:any)=>noCHangeFilterElement.id == savedFilterElement)
              if(newElementToAdd){
                if(!this.savedFilters[key]){
                  this.savedFilters[key] = []
                }
                this.savedFilters[key].push(newElementToAdd)
              }
            });
          }
        }
        this.filtersToApply = this.savedFilters
      },
      error: () => {
        this.loader.off(true)
      }
    })
  }

  changeFilters(event: any, name: string) {
    if (name == 'status') {
      this.filtersToApply[name] = event.label
    } else {
      if (name == 'exact' || name == 'order') {
        this.filtersToApply[name] = event.value
      } else {
        this.filtersToApply[name] = event
      }
    }
  }

}
